import ActivityCard from './ActivityCard';

export default ActivityCard;
